import React from 'react';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Item = styled(Paper)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? 'transparent' : '#fff',
    boxShadow: 'none',
    ...theme.typography.body2,
    padding: theme.palette.mode === 'dark' ? 0 : theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export const GrayText = {
    color: '#828a99',
    fontSize: 16,
    lineHeight: 1.37,
};

export const TitleText = (
    color = '#fff',
    fontSize = 24,
    fontWeight = 700,
    lineHeight = 1.08,
    textTransform = 'capitalize') => (
    {
        color: color,
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textTransform: textTransform,
        '& a': {
            color: color,
        },
    });

export const SimpleText = (
    color = '#fff',
    fontSize = 16,
    fontWeight = 400,
    lineHeight = 1.37) => ({
        color: color,
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        '& a': {
            color: color,
        },
    });

export const OrSeparator = ({ label = 'OR', pos = '135%' }) => (
    <Box className="separator" sx={{
        position: 'relative',
        fontSize: 20,
        lineHeight: 1.4,
        overflow: 'hidden',
        maxWidth: 300,
        width: '100%',
        m: '20px auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& span': {
            display: 'block',
            position: 'relative',
            zIndex: 2,
        },
        '& span:before,& span:after': {
            position: 'absolute',
            content: '""',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '33vw',
            height: '2px',
            background: '#fff'
        },
        '& span:before': {
            right: pos,
        },
        '& span:after': {
            left: pos,
        },
    }}>
        <span>{label}</span>
    </Box>
);